/**
 * Split a report's settings schema for the group report New / Edit page.
 *
 * Template-only sections (the send schedule: frequency, delivery day, Room
 * Condition's send times) belong in the page's Report Details card, beside
 * the name and group. Everything else is a settings card, exactly as on the
 * On Demand page. A section is template-only when it is marked `savableOnly`,
 * or when its `showIf` shows it only for a saved template (isSavable).
 */
const scope = (isSavable) => ({isSavable, settings: {}, interval: 'monthly', variant: 'cards', can: () => true})

const shownWhen = (section, isSavable) => {
    try {
        return section.showIf(scope(isSavable)) !== false
    } catch (error) {
        // A condition that needs real settings is about the report's content,
        // not the schedule.
        return true
    }
}

const isTemplateOnly = (section) => section.savableOnly === true || (
    typeof section.showIf === 'function'
    && ! shownWhen(section, false)
    && shownWhen(section, true)
)

export function splitTemplateSchema(schema) {
    const sections = schema?.sections ?? []

    return {
        detailFields: sections.filter(isTemplateOnly).flatMap((section) => section.fields ?? []),
        settingsSchema: {...schema, sections: sections.filter((section) => ! isTemplateOnly(section))},
    }
}
